import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Login } from 'src/app/models/login';
import { LoginResponse, LoginResponseSchema } from 'src/app/models/api-response/user';
import { parseResponse } from './parse-response.operator';

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  newPasswordConfirmation: string;
}

export interface ChangePasswordResponse {
  status: string;
  code: number;
  message?: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserAuthService {
  private readonly basePath = `${environment.API_URL}${environment.API_VERSION}/client-services/`;

  constructor(private readonly http: HttpClient) {}

  login(user: Login): Observable<LoginResponse> {
    const body = 'json=' + JSON.stringify(user);
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http
      .post<LoginResponse>(`${this.basePath}login`, body, { headers })
      .pipe(parseResponse(LoginResponseSchema));
  }

  /**
   * Cliente portal: coincide con `Route::put('.../client-services/users/change-password', ...)` en Laravel.
   */
  changePassword(payload: ChangePasswordRequest): Observable<ChangePasswordResponse> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put<ChangePasswordResponse>(`${this.basePath}users/change-password`, payload, {
      headers,
    });
  }
}
